import type { Guide } from "@/types";
import { useApi } from "@/composables/useApi";
import { normalizeGuideBio } from "@/utils/normalizeGuideBio";

export const useGuidesApi = () => {
  const API = useApi();

  const getGuides = async (
    params: {
      limit?: number;
      offset?: number;
      city?: number;
    } = {},
  ): Promise<Guide[]> => {
    return await API.get<Guide[]>(`/main/users/guides/`, { params });
  };

  const getGuideBySlug = async (
    slug: string,
    affiliateCode?: string,
    guideAccessToken?: string,
  ): Promise<Guide> => {
    const affiliateCookie = useCookie(`affiliate_code_${slug}`);
    const guideAccessTokenCookie = useCookie(`guide_access_token_${slug}`);
    const code = affiliateCode ?? affiliateCookie.value;
    const accessToken = guideAccessToken ?? guideAccessTokenCookie.value;
    const headers = {
      ...(code ? { "X-Affiliate-Code": code } : {}),
      ...(accessToken ? { "X-Guide-Access-Token": accessToken } : {}),
    };
    const guide = await API.get<Guide>(`/main/users/guides/${slug}/`, {
      headers,
    });
    return normalizeGuideBio(guide);
  };

  return {
    getGuides,
    getGuideBySlug,
  };
};
